import { useCallback, useState } from 'react';

const QUOTA_KEY = 'uc_gsq';

function getToday(): string {
	return new Date().toISOString().slice( 0, 10 );
}

function readQuota( max: number ): number {
	const safeMax = Number.isFinite( max ) ? Math.max( 0, Math.trunc( max ) ) : 1;

	try {
		const raw = localStorage.getItem( QUOTA_KEY );
		if ( ! raw ) {
			return safeMax;
		}
		const parsed = JSON.parse( raw ) as { n?: unknown; d?: unknown };
		if ( typeof parsed.n !== 'number' || parsed.d !== getToday() ) {
			return safeMax;
		}
		return Math.min( safeMax, Math.max( 0, Math.trunc( parsed.n ) ) );
	} catch {
		return safeMax;
	}
}

function saveQuota( n: number ): void {
	try {
		localStorage.setItem( QUOTA_KEY, JSON.stringify( { n, d: getToday() } ) );
	} catch {
		// localStorage unavailable — silently continue
	}
}

export default function useSearchQuota( isLoggedIn: boolean, maxGuestSearches: number ) {
	const [ remainingSearches, setRemainingSearches ] = useState( () =>
		isLoggedIn ? maxGuestSearches : readQuota( maxGuestSearches )
	);

	const decrementQuota = useCallback( () => {
		if ( isLoggedIn ) {
			return;
		}
		setRemainingSearches( ( prev ) => {
			const next = Math.max( 0, prev - 1 );
			saveQuota( next );
			return next;
		} );
	}, [ isLoggedIn ] );

	return { remainingSearches, decrementQuota };
}
